import { AGENTS_CONTRACT_PERIOD_MONTH, AGENTS_TYPE_EXTERNAL } from '@/consts/agents'
import {
  AGENT_EXPORT_HOURS_DATA,
  AGENT_EXPORT_HOURS_KEY_HOURS,
  AGENT_EXPORT_HOURS_KEY_UNAVAILABILITIES
} from '@/consts/agentsExport'
import store from '@/store'

export const userName = ({ firstname, lastname, agentInfos } = {}, sep = ' ') =>
  (agentInfos && agentInfos.type === AGENTS_TYPE_EXTERNAL
    ? [agentInfos.externalCompanyName]
    : [firstname, lastname]
  ).join(sep) || 'Aucun agent'

export const getWorkingLimit = (u) => {
  const hoursLimit = _.get(u, ['agentInfos', 'activeContract', 'hoursLimit'])
  const period = _.get(u, ['agentInfos', 'activeContract', 'period'])
  return (period === AGENTS_CONTRACT_PERIOD_MONTH ? hoursLimit : Math.round(hoursLimit * 52 / 12 * 100) / 100) || 0
}

/**
 * Retourne la liste des champs d'export en fonction de l'agence actuelle
 * @param summarise - Retourne les totaux heures et indisponibilités
 * @return {[]}
 */
export const agentExportHoursData = (summarise = true) => {
  const { saturdayCount } = store.getters['user/company']
  const agencyHoursData = AGENT_EXPORT_HOURS_DATA
    .filter((hours) => !hours.saturday || (saturdayCount && hours.saturday))
  return summarise
    ? agencyHoursData
    : agencyHoursData.filter(({ key }) =>
      [
        AGENT_EXPORT_HOURS_KEY_HOURS,
        AGENT_EXPORT_HOURS_KEY_UNAVAILABILITIES
      ].indexOf(key) === -1)
}
